import {useRef} from "react";
import {useLayoutEffect} from "./use_isomorphic_layout_effect";

function useAtBottom(callback) {
    const ref = useRef(null);
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    useLayoutEffect(() => {
        function onScroll() {
            if (ref.current) {
                const rect = ref.current.getBoundingClientRect();
                const atBottom = rect.top <= (window.innerHeight || document.documentElement.clientHeight);
                if (atBottom && typeof callbackRef.current === 'function') {
                    callbackRef.current();
                }
            }
        }
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, [callbackRef]);
    return <div ref={ref}/>;
}

export default useAtBottom;
